import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { PORTAL_CODE } from '../../config/portalBranding';

const META_PIXEL_ID = '926825883707714';

export default function MetaPixel() {
  const location = useLocation();
  // Three-condition gate:
  //   1. Runtime hostname must be panel.nipponpolls.com (defense-in-depth against
  //      a mis-deployed build being served to a different country's domain).
  //   2. Build-time PORTAL_CODE must be 'JP' (compile-time guard).
  //   3. Hash-internal query param loginRewardType must equal 'facebook'.
  //      useLocation() from react-router-dom correctly exposes the hash
  //      fragment's internal search string, so this works for hash-based routes.
  const params = new URLSearchParams(location.search);
  const shouldFire =
    window.location.hostname === 'panel.nipponpolls.com' &&
    PORTAL_CODE === 'JP' &&
    params.get('loginRewardType') === 'facebook';

  useEffect(() => {
    if (!shouldFire) return;

    // One-time initialization: defines window.fbq and loads the FB events script
    if (!window.fbq) {
      /* eslint-disable */
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      /* eslint-enable */
      // _fbc cookie is set by normalizeTrackingParams() at bootstrap before
      // fbevents.js loads — pixel reads it from the cookie automatically.
      window.fbq('init', META_PIXEL_ID);
    }

    // Fire PageView on initial mount AND on every route change
    window.fbq('track', 'PageView');
  }, [shouldFire, location.pathname]);

  // Render <noscript> fallback for users with JS disabled — same two-condition gate
  if (!shouldFire) return null;

  return (
    <noscript>
      <img
        height="1"
        width="1"
        style={{ display: 'none' }}
        src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`}
        alt=""
      />
    </noscript>
  );
}
